import React from "react";
import { ArrowRight } from "lucide-react";
import PremiumBadge from "./PremiumBadge";
import { useI18n } from "../../i18n/I18nContext";

const CoachingCard = ({ session, onBook }) => {
  const { t } = useI18n();
  return (
  <div className="group rounded-2xl border border-slate-200 overflow-hidden bg-white hover:shadow-lg transition-shadow">
    <div className="relative overflow-hidden aspect-[16/10] bg-slate-100 hover-zoom">
      <img src={session.image} alt={session.title} className="w-full h-full object-cover" loading="lazy" />
      <div className="absolute top-3 left-3 flex gap-2">
        <span className="bg-white/90 text-[#0a2540] text-[10px] font-700 uppercase tracking-wider px-2.5 py-1 rounded">
          {session.type}
        </span>
        {session.premium && <PremiumBadge />}
      </div>
    </div>
    <div className="p-6">
      <h3 className="font-display font-700 text-lg text-[#0a2540]">{session.title}</h3>
      <p className="mt-1 text-sm text-slate-500">{t("withCoach")} {session.coach} &middot; {session.length}</p>
      <button
        onClick={() => onBook(session)}
        className="mt-5 w-full inline-flex items-center justify-center gap-2 bg-[#0a2540] hover:bg-[#16355c] text-white font-600 px-6 py-3 rounded-full transition-colors"
      >
        {t("bookSession")} <ArrowRight className="w-4 h-4" />
      </button>
    </div>
  </div>
  );
};

export default CoachingCard;
